module.exports = __webpack_public_path__ + "img/MKKLogo.e3b33815.png";